<div class="template-gallery">
  <nz-empty 
    *ngIf="templates.length === 0"
    [nzNotFoundContent]="'builderScreen.events.empty.noTemplates' | translateTA"
    [nzNotFoundImage]="'simple'">
  </nz-empty>

  <div class="gallery-grid" *ngIf="templates.length > 0">
    <nz-card
      *ngFor="let template of templates"
      class="template-card"
      [class.template-selected]="isSelected(template)"
      nzHoverable
      (click)="selectTemplate(template)">
      
      <div class="template-header">
        <nz-icon [nzType]="template.icon" nzTheme="outline" class="template-icon"></nz-icon>
        <h4 class="template-name">{{ template.name }}</h4>
      </div>

      <p class="template-description">{{ template.description }}</p>

      <div class="template-footer">
        <nz-tag [nzColor]="getCategoryColor(template.category)">
          {{ getCategoryLabel(template.category) }}
        </nz-tag>
        
        <nz-icon 
          *ngIf="isSelected(template)" 
          nzType="check-circle" 
          nzTheme="fill" 
          class="selected-icon">
        </nz-icon>
      </div>
    </nz-card>

    <nz-card
      class="template-card template-create-new"
      nzHoverable
      (click)="selectTemplate(null)">
      
      <div class="template-header">
        <nz-icon nzType="plus-circle" nzTheme="outline" class="template-icon"></nz-icon>
        <h4 class="template-name">{{ 'builderScreen.events.gallery.createNew' | translateTA }}</h4>
      </div>

      <p class="template-description">
        {{ 'builderScreen.events.gallery.customDescription' | translateTA }}
      </p>

      <div class="template-footer">
        <nz-tag nzColor="default">{{ 'builderScreen.events.gallery.custom' | translateTA }}</nz-tag>
      </div>
    </nz-card>
  </div>
</div>



